import {
    Paper,
    Typography
} from '@mui/material'


const StatCard = ({ label, value }) => (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
        <Typography variant="body2" color="text.secondary">
            {label}
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 800, mt: 0.5 }}>
            {value}
        </Typography>
    </Paper>
)

export default StatCard